module.exports = __webpack_public_path__ + "static/media/onyx_350_350.8c959574.png";